export const SUPPORTS_OBJECT_IS_SEALED = "isSealed" in Object;
